export default __webpack_public_path__ + "media/images/reticle-6490ecbb61185e86e62dca0845cf2dcf.png";